import { Component, OnInit, Input } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { FormGroup, FormBuilder, Validators , FormControl  } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {  Directive, ElementRef, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAproRepLegComponent } from '../modal-apro-rep-leg/modal-apro-rep-leg.component';
import { ModalRechRepLegComponent } from '../modal-rech-rep-leg/modal-rech-rep-leg.component';
import { ModalCertDdjjFormComponent } from '../modal-cert-ddjj-form/modal-cert-ddjj-form.component';

//declare let gtag: (property: string, value: any, configs: any) => {};
 
 
declare let gtag: Function;

@Component({
  selector: 'app-primer',
  templateUrl: './primer.component.html',
  styleUrls: ['./primer.component.css'],
 
})

export class PrimerComponent implements OnInit {
  rut: string;
  nombre: string;
  noarchivo=false;
  notipopdf=false;
  apellidop: string;
  apellidom: string;
  ngOnInit(): void {};
  code:string;
  state:string;
  isModalOpenA = false;
  isModalOpenR = false;
  solPendientes:any;
  haySolPend:boolean=false;
  selectedRowData: any;
  form: FormGroup;

  private solpendientes:string = environment.solpendientes;
  private getdoctos:string = environment.getdoctos;
  private getsolicitud:string = environment.detsolicitud;
  private aniosDJ:string = environment.periodos;
  swtDJ:string;

  mostrar=false;
  constructor (
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router, 
    el: ElementRef, 
    renderer: Renderer2, 
    private toastr: ToastrService,
    public detalleUsuarioService : DetalleUsuarioService,
    public parametroAccion : ParametroAccionService,
    private modalService: NgbModal ) {
    
    this.form = this.fb.group({
      solicitud: []
    });
    var events = 'cut copy paste';
    events.split(' ').forEach(e => 
      renderer.listen(el.nativeElement, e, (event) => {
        event.preventDefault();
      })
    );

    if ( (this.code == null || this.code == 'undefined') && localStorage.getItem('code') != null ) { 
      this.code = localStorage.getItem('code');
    }
  
    if ( (this.state == null || this.state == 'undefined') && localStorage.getItem('state') != null ) { 
      this.state = localStorage.getItem('state');
    }
    //
    
    //let urltoken = `${ this.creamenu}`;
    //console.log(this.rut);
    this.rut=this.detalleUsuarioService.obtenerRut();

    //console.log(this.rut);
     
    if ( (this.rut == null || this.rut == '0') && (localStorage.getItem('rut') != null )) this.rut = localStorage.getItem('rut');
    if ( (this.nombre == null || this.nombre=='')  && (localStorage.getItem('nombre') != null )) this.nombre = localStorage.getItem('nombre'); 
    if ( (this.apellidop == null || this.apellidop == '') && (localStorage.getItem('apellidop') != null ) ) this.apellidop = localStorage.getItem('apellidop');
    if ( (this.apellidom == null || this.apellidom == '') && (localStorage.getItem('apellidom') != null ) ) this.apellidom = localStorage.getItem('apellidom');

    /****************Valida si tiene cert DJ*****************/
    this.http.post<any>(this.aniosDJ, { 
      rut:this.detalleUsuarioService.obtenerRut()
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      const cant = data.Resultados.length;
      if (cant>0 ) {
        this.swtDJ='S';
        this.detalleUsuarioService.actualizarSwtDJ(this.swtDJ);
        console.log(this.swtDJ);
        this.certForm();
      }else{
        this.swtDJ='N';
        this.detalleUsuarioService.actualizarSwtDJ(this.swtDJ);
        console.log(this.swtDJ);
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
    /****************Fin Valida si tiene cert DJ*****************/
    //this.getSolPendientes();


   
  }

  certForm(){
    const modalRef =this.modalService.open(ModalCertDdjjFormComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        // El modal se cerró correctamente
        //this.getCuentas();
      },
      () => {
        // Se cerró el modal con dismiss
        //this.getCuentas();
        
      }
    );
    //eliminar lo siguiente si es modal.
    //this.router.navigate(['/inicio']);
  }

  formAddEmpr(){
    this.router.navigate(['/empresa-form']);
  }

  formAddRepr(){
    this.router.navigate(['/rut-empresa-form']);
  }

  file:any;
  archivob64: string;
  file2:any;
  archivob642: string;
 
  onSubmit(){
    this.http.post<any>(this.getsolicitud, { 
      numero_solicitud:this.form.get('solicitud').value
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.parametroAccion.guardarDatos(data.Consulta);
          
          this.router.navigate(['/det-solicitud']);
        }else{
          this.toastr.error("No se encuentra registro.");
        }
      }else{
        this.toastr.error("No se encuentra registro.");
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  getSolPendientes(){
    this.http.post<any>(this.solpendientes, { 
      region:""
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.haySolPend=true;
          this.solPendientes=data.Consulta;
        }else{
          this.haySolPend=false;
        }
      }else{
        this.haySolPend=false;
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

  verInicio(){
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }

  cerrar(){
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }

  openModalA(item: any) {
    this.parametroAccion.guardarDatos(item);
    const modalRef =this.modalService.open(ModalAproRepLegComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        // El modal se cerró correctamente
        this.getSolPendientes();
      },
      () => {
        // Se cerró el modal con dismiss
        this.getSolPendientes();
      }
    );
  }

  openModalR(item: any) {
    this.parametroAccion.guardarDatos(item);
    const modalRef =this.modalService.open(ModalRechRepLegComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        // El modal se cerró correctamente
        this.getSolPendientes();
      },
      () => {
        // Se cerró el modal con dismiss
        this.getSolPendientes();
      }
    );
  }

  downloadFile1(item: any){
    let llave1 = item.RUT_REPRESENTANTE;
    let llave2 = item.RUT_EMPRESA;
    let llave3 = item.SEQ_NRO_SOLICITUD_CDG;
    this.downloadFile(llave1, llave2, llave3, "0");
  }

  downloadFile2(item: any){
    let llave1 = item.RUT_REPRESENTANTE;
    let llave2 = item.RUT_EMPRESA;
    let llave3 = item.SEQ_NRO_SOLICITUD_CDG;
    this.downloadFile(llave1, llave2, llave3, "1");
  }

  downloadFile(llave1: String, llave2: String, llave3: String, llave4: String){
    let filename:String;
    let urlPDF: String;
    this.http.post<any>(this.getdoctos, { 
      rut_representante : llave1,
      rut_empresa       : llave2,
      nrosolicitud      : llave3,
      nroarchivo        : llave4
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        filename = data.nombre;
        urlPDF = data.URL;
        window.open(data.URL, '_blank');
        //this.haySolPend=true;
        //this.solPendientes=data.Consulta;
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }
  
}// fin de export

